<template>
  <div class="history">
    <div class="header">History Outbound</div>
    <div class="report mt-2">
      <div
        v-for="(leadHome, index) in leadHomeReportHistoryPresenters"
        :key="index"
        :class="{ header: index === 0 }"
        class="lead-history-report-row"
      >
        <div class="report-cell center">
          {{ leadHome.contactDate }}
        </div>
        <div class="report-cell">
          {{ leadHome.projectName }}
        </div>
        <div class="report-cell center">
          {{ leadHome.houseNo }}
        </div>
        <div class="report-cell">
          {{ leadHome.customerName }}
        </div>
        <div class="report-cell">
          {{ leadHome.mobileNo }}
        </div>
        <div class="report-cell">
          {{ leadHome.name }}
        </div>
        <div class="report-cell center">
          <div v-if="index === 0">
            {{ leadHome.statusLabel }}
          </div>
          <div
            v-else
            :class="leadHome.statusValue"
            class="lead-status-badge center"
          >
            {{ leadHome.statusLabel }}
          </div>
        </div>
        <div class="report-cell">
          {{ leadHome.reason }}
        </div>
        <div class="report-cell">
          {{ leadHome.remark }}
        </div>
        <div class="report-cell">
          {{ leadHome.contactBy }}
        </div>
        <div class="report-cell">
          {{ leadHome.package }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import { toCamelCaseObject } from "@/lib/util"
import { convertDateTimeToTimeText } from "@/lib/dateTime"
import { leadHomeStatusMapper, leadManagementReason } from "@/lib/mapper"

export default {
  name: "LeadContactHistoryReport",
  props: {
    homeId: {
      type: String,
      default: undefined,
    },
    leadHomeStatus: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      contactHistories: [],
    }
  },
  computed: {
    leadHomeReportHistoryPresenters() {
      const header = {
        contactDate: "วันที่ติดต่อ",
        projectName: "โครงการ",
        houseNo: "บ้านเลขที่",
        customerName: "ชื่อลูกค้า",
        mobileNo: "เบอร์โทร",
        name: "ชื่อ Lead",
        statusLabel: "สถานะการขาย",
        reason: "เหตุผล",
        remark: "หมายเหตุ",
        contactBy: "ผู้รับผิดชอบการขาย",
        package: "แพ็คเกจ",
      }

      return [header, ...this.contactHistories]
    },
  },
  watch: {
    async homeId() {
      await this.setupData()
    },
  },
  created() {},
  methods: {
    setup() {
      this.setupData()
    },
    async setupData() {
      await this.setupContactHistories()
    },
    async setupContactHistories() {
      const result = await this.fetchContactHistories()

      this.contactHistories = toCamelCaseObject(result.history_list).map(
        (history) => {
          const statusItem = leadHomeStatusMapper.find(
            (item) => item.value === history.status,
          )

          const statusLabel =
            statusItem && statusItem.label ? statusItem.label : "ไม่มี สถานะ"

          const statusValue =
            statusItem && statusItem.value ? statusItem.value : "UNKNOW"

          const reason = history.reason
            ? leadManagementReason.find((i) => i.value === history.reason).label
            : "-"

          return {
            ...history,
            customerName: `${history.firstName} ${history.lastName}`,
            contactDate: convertDateTimeToTimeText(
              history.contactDate,
              "dd MMM yyyy",
            ),
            statusLabel,
            statusValue,
            reason,
            remark: history.remark || "-",
            package: history.package || "-",
          }
        },
      )
    },
    async fetchContactHistories() {
      if (!this.homeId) {
        this.contactHistories = []
        return []
      }

      const response =
        await baanRueJaiClient.admin.lead.getHomeContactHistoryList(this.homeId)

      return response.data.result
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../lead";

.lead-history-report-row {
  display: grid;
  grid-template-columns:
    120px
    180px
    80px
    160px
    100px
    150px
    120px
    120px
    150px
    160px
    200px;
}

.lead-history-report-row:first-child {
  position: sticky;
  top: -30px;

  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
  }
}

.report-cell {
  font-size: 14px;
  padding: 10px;
}

.center {
  text-align: center;
}

.header {
  font-weight: bold;
  font-size: 22px;
}
</style>
